import React from "react";
import { UIText } from "../ui/text/text.js";
import { Button, Form, Input, Modal, notification } from "antd";
import { ModelAuth } from "../../model/auth.js";
import { v4 } from "uuid";
import { AuthContext } from "./auth-provider.js";

const AuthResetPassword = function (props) {
  const { visible, setModal } = props;
  const { setUser } = React.useContext(AuthContext);
  const onSubmit = (values) => {
    const onSuccess = (response) => {
      props.onSuccess && props.onSuccess();
      props.onClose && props.onClose();
    };

    const onFailure = () => {
      notification.error({
        message: "Email is niet bij ons bekend. Voer de Email in die je hebt gebruikt bij de bestelling.",
      });
    };
    ModelAuth.resetPW({email:values.email}, onSuccess, onFailure);
  };

  return props.onClose ? (
    <Modal
      onCancel={props.onClose}
      title={"Wachtwoord vergeten?"}
      maskClosable={false}
      footer={false}
      className={"modal"}
      visible={visible}
    >
      <p>Oeps! Het lijkt erop dat je de wachtwoord van jouw MyFCU-account vergeten bent. Maar wees niet getreurd. Via onderstaand formulier kan je gemakkelijk jouw wachtwoord resetten en weer toegang krijgen tot alle MyFCU functionaliteiten.</p>
      <Form layout={"vertical"} onFinish={onSubmit}>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Email is verplicht!" },
            { type: "email", message: "Geen geldig email adres." },
          ]}
        >
          <Input placeholder={"Email"} />
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="contact-form-button"
        >
          Nieuw wachtwoord aanvragen
        </Button>
      </Form>
      <div className={"modal-footer"}>
        <div className={"modal"}>
          <div className={"modal-footer"} />
        </div>
      </div>
    </Modal>
  ) : (
    <Form layout={"vertical"} onFinish={onSubmit}>
      <Form.Item
        name="email"
        label="Email factuurhouder"
        rules={[
          { required: true, message: "Email is verplicht!" },
          { type: "email", message: "Geen geldig email adres." },
        ]}
      >
        <Input placeholder={"Email"} />
      </Form.Item>
      <Form.Item
        name="password"
        label="Wachtwoord"
        rules={[{ required: true, message: "Wachtwoord is verplicht" }]}
      >
        <Input.Password placeholder={"Wachtwoord"} />
      </Form.Item>
      <Button type="primary" htmlType="submit" className="contact-form-button">
        Login
      </Button>
    </Form>
  );
};

export { AuthResetPassword };
